/**
 * Общее форматирование чисел и времени для гаджетов.
 *
 * Живёт отдельным модулем, чтобы «1 ч 5 мин» и «125 000 ₽» выглядели
 * одинаково во всех гаджетах: расхождение в записи одной и той же
 * величины на соседних карточках читается как ошибка данных.
 */

export const RUB = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 })

const NUM = new Intl.NumberFormat('ru-RU')

/** 45100 -> «45 100» — пробеги и прочие количества. */
export function formatNumber(n) {
  return NUM.format(n)
}

export function formatDuration(min) {
  const h = Math.floor(min / 60)
  const m = Math.round(min % 60)
  return h ? `${h} ч ${m} мин` : `${m} мин`
}

export const HOURS = Array.from({ length: 24 }, (_, i) => (i % 3 === 0 ? String(i) : ''))
export const WEEKDAYS = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс']
